import axios from "axios";
import { msalInstance, apiTokenRequest } from "./msalConfig";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
});

// Attach Azure ID token to every API request.
api.interceptors.request.use(async (config) => {
    try {
        const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
        if (account) {
            const result = await msalInstance.acquireTokenSilent({
                ...apiTokenRequest,
                account,
            });
            const token = result.idToken;
            if (token) {
                config.headers = config.headers || {};
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
    } catch (e) {
        // Silent acquire can fail (interaction required); request will then 401
        // and the AuthContext will redirect to login.
    }
    return config;
});

export function formatApiError(err, fallback = "Something went wrong") {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const photoUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${BACKEND_URL}${path}`;
};
